module.exports = "<h4 style=\"padding-top: 22px;\">Page not found</h4>\n\n<p>\n    <br />\n    Sorry, that page could not be found.\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /Users/masonpimentel/Repos/mason-blog/src/app/page-not-found/page-not-found.component.html
// module id = ../../../../../src/app/page-not-found/page-not-found.component.html
// module chunks = main